import axios from "axios";
import { buildAxiosAuthenticationHeaders } from "../util/build-axios-authentication-headers";
import { querytimescaleUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";
import { UnitsResponse } from "@src/types/units";

export interface GetUnitsParams {
  namespace: string;
}

export type GetUnitsApiResult =
  | { success: true; data: UnitsResponse }
  | { success: false; error: string; status?: number };

export const getUnits = async ({
  namespace,
}: GetUnitsParams): Promise<GetUnitsApiResult> => {
  try {
    const response = await axios.get<UnitsResponse>(
      `${querytimescaleUrlEnvVar()}/api/v2/ns/${namespace}/units`,
      { headers: buildAxiosAuthenticationHeaders() },
    );

    return { success: true, data: response.data };
  } catch (error) {
    const { message, status } = parseAxiosApiError(
      error,
      "Failed to fetch units",
    );
    return { success: false, error: message, status };
  }
};
